import {Warranty} from "../helpers/warranty/Warranty";
import {StepSlider} from "./stepslider/StepSlider";
import {Carousel} from "react-responsive-3d-carousel";

function Title(title, id) {
    if (!id) {
        return (
            <div>
                <h3>{title}</h3>
            </div>
        )
    }
}

const MEDIA_ARRAY = [
    <img key="slide_06" src="/assets/portfolio/0006.webp" alt="slide_01"/>,
    <img key="slide_07" src="/assets/portfolio/0007.webp" alt="slide_02"/>,
    <img key="slide_08" src="/assets/portfolio/0008.webp" alt="slide_03"/>,
];

export const Concrete = () => {
    return (
        <main className="concrete__container">
            <Warranty duration={20} />
            <section>
                <h2>Proceso de construcción</h2>
                <p>Dar lo mejor es darte una piscina que tenga durabilidad y calidad.</p>
            </section>
            <section>
                <StepSlider />
            </section>
            <section>
                {
                    Title('Nuestros trabajos')
                }
                <Carousel spread={"narrow"} showStatus={false} interval={4000} depth={6} showIndicators={false}>
                    { MEDIA_ARRAY }
                </Carousel>
            </section>
        </main>
    )
}
